import moment from 'moment';
import APIUtils from '@spothero/utils/api';

export const DEFAULT_EVENTS_PAGE_SIZE = 150;

const EventsAPI = {
    get({
        destinationId,
        pageSize = DEFAULT_EVENTS_PAGE_SIZE,
        eventTypes = null,
        starts = moment().format(),
    }) {
        /* eslint-disable camelcase */

        const data = {
            destination_id: destinationId,
            page_size: pageSize,
            starts,
            include: 'search_url',
        };

        if (eventTypes) {
            data.event_types = eventTypes;
        }
        /* eslint-enable camelcase */

        return APIUtils.get('events/', data);
    },
};

export default EventsAPI;
